const baseUrl = import.meta.env.VITE_API_URL?.trim() || '';

export function asAbsoluteUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  return `${baseUrl}${url}`;
}
